import SmartFeedEngine from "~/smart-feed/smart-feed-engine";
import { defineSmartFeedPiniaStore } from "@bloglovin/vue-framework";
import useFanPublicationStore from "%/stores/fan-publication-store";

export const useMyPublicationPostFeedStore = defineSmartFeedPiniaStore("publication-post-feed-store", {
  state: () => ({
    smartFeedEngine: new SmartFeedEngine(),
    metadata: {
      lastId: Number.MAX_SAFE_INTEGER,
      publicationId: useFanPublicationStore().publicationId,
    },
  }),
  getters: {
    feedUrl() {
      return `/publication/${this.metadata.publicationId}/post/smart-feed/filtered`;
    },
  },
});
